<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-ban"></i> Cancel Airbnb Booking</h5>
  <button (click)="dialogRef.close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="alert alert-danger" *ngIf="!!penaltyAmountUsdAccurate">
      <i class="fas fa-exclamation-triangle"></i>
      You will be charged with penalty of ${{ penaltyAmountUsdAccurate }} amount if you cancel the booking.
    </div>
    <div class="alert alert-danger" *ngIf="noAirbnbCancelReason">
      <i class="fas fa-exclamation-triangle"></i>
      Airbnb is not allowing this to be canceled, but you can still cancel this booking in Tokeet only.
    </div>
    <mat-form-field class="mat-block">
      <mat-select formControlName="reason" placeholder="Cancel Reason" required>
        <mat-option
          *ngFor="let item of reasons"
          [matTooltip]="item.description"
          matTooltipPosition="right"
          [value]="item.id"
        >
          {{ item.title }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="form.get('reason').touched && form.get('reason').hasError('required')">
        Reason is required.
      </mat-error>
    </mat-form-field>
    <mat-form-field class="mat-block">
      <textarea matInput placeholder="Message to guest" rows="3" formControlName="message_to_guest"></textarea>
      <mat-error *ngIf="form.get('message_to_guest').touched && form.get('message_to_guest').hasError('required')">
        Message to guest is required.
      </mat-error>
      <mat-error *ngIf="form.get('message_to_guest').hasError('minlength')">
        min message length is <strong>30</strong>
      </mat-error>
      <mat-error *ngIf="form.get('message_to_guest').hasError('maxlength')">
        max message length is <strong>240</strong>
      </mat-error>
    </mat-form-field>
  </form>
</div>
<div class="modal-footer">
  <button (click)="dialogRef.close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button
    (click)="onCancel()"
    matTooltip="Cancel this booking in Tokeet only."
    type="button"
    [disabled]="isLoading"
    class="btn btn-cst-info text-uppercase create-btn"
  >
    <i class="fal fa-ban"></i> Cancel in Tokeet
  </button>

  <button
    (click)="onDecline(form)"
    type="button"
    [disabled]="isLoading || noAirbnbCancelReason"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-ban"></i> Decline
  </button>
</div>
